import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home/home";
import Benefits from "./pages/Careers/benefits";
import Careers from "./pages/Careers/careers";
import Interviewing from "./pages/Careers/Interviewing";
import Job from "./pages/Careers/job";
import Language from "./pages/Language/language";
import About from "./pages/About/about";
import Beta from "./pages/Beta/beta";
import Login from "./pages/Auth/Login";

import "./app.css";
import Header from "./components/Header/Header";
import MobileHeader from "./components/Header/MobileHeader";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { headerData, footerData } from "./Markup";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faTimes,
  faChevronLeft,
  faServer,
  faChevronRight,
  faPlusSquare,
  faHeart,
  faDesktop,
  faSpinner,
  faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";
import {
  fab,
  faGithub,
  faLinkedin,
  faMedium,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";
import CreateAccount from "./pages/CreateAccount/index";
import UsernameCheck from "./pages/UsernameCheck/UsernameCheck";
import SignUp from "./pages/SignUp/";

library.add(
  fab,
  faGithub,
  faLinkedin,
  faMedium,
  faTwitter,
  faBars,
  faTimes,
  faChevronLeft,
  faChevronRight,
  faServer,
  faPlusSquare,
  faHeart,
  faDesktop,
  faSpinner,
  faQuestionCircle
);

const mobile =
  typeof window.orientation !== "undefined" ||
  navigator.userAgent.indexOf("IEMobile") !== -1;
class App extends React.Component {
  renderComponents = component => {
    return (
      <div className="App">
        {mobile ? (
          <MobileHeader
            headerData={headerData}
            location={window.location.pathname}
          />
        ) : (
          <Header
            key={window.location.pathname}
            headerData={headerData}
            location={window.location.pathname}
          />
        )}
        {component}
        <Footer mobile={mobile} footerData={footerData} />
      </div>
    );
  };
  render() {
    return (
      <Router>
        <ScrollToTop>
          <Switch>
            <Route
              path="/"
              exact
              component={() => this.renderComponents(<Home />)}
            />
            <Route
              path="/careers/"
              exact
              component={() => this.renderComponents(<Careers />)}
            />
            <Route
              path="/careers/benefits"
              component={() => this.renderComponents(<Benefits />)}
            />
            <Route
              path="/careers/interviewing"
              component={() => this.renderComponents(<Interviewing />)}
            />
            <Route
              path="/careers/:title-:title2"
              component={location => {
                return this.renderComponents(
                  <Job
                    title={
                      location.match.params.title +
                      "-" +
                      location.match.params.title2
                    }
                  />
                );
              }}
            />
            <Route
              path="/careers/:title"
              component={location => {
                return this.renderComponents(
                  <Job title={location.match.params.title} />
                );
              }}
            />
            <Route
              path="/language"
              component={() => this.renderComponents(<Language />)}
            />
            <Route
              path="/about"
              component={() => this.renderComponents(<About />)}
            />
            <Route
              path="/beta"
              component={props => {
                return this.renderComponents(
                  <Beta location={props.location} />
                );
              }}
            />
            <Route
              path="/create-acc"
              component={() => this.renderComponents(<CreateAccount />)}
            />
            <Route
              path="/signup"
              component={props => {
                return this.renderComponents(
                  <SignUp
                    token={(props.location.search || "").replace("?", "")}
                  />
                );
              }}
            />
            <Route
              path="/isUsernameAvailable"
              component={() => this.renderComponents(<UsernameCheck />)}
            />
            <Route
              path="/login"
              component={() => this.renderComponents(<Login />)}
            />
            {/* when none of the above match, <NoMatch> will be rendered */}
            <Route
              path="*"
              component={() => this.renderComponents(null)}
              status={404}
            />
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;
